export const STUDY_INITIALIZE_WORKFLOW = 'STUDY_INITIALIZE_WORKFLOW';
export const STUDY_ON_FIELD_CHANGE = 'STUDY_ON_FIELD_CHANGE';


export function initializeStudyWorkflow() {
    return dispatch => {
        dispatch({
            type: STUDY_INITIALIZE_WORKFLOW,
        });
    };
}


export function setField(fieldName, fieldValue) {
    return dispatch => {
        dispatch({
            type: STUDY_ON_FIELD_CHANGE,
            payload: {
                fieldName,
                fieldValue
            }
        });
    };
}


